import JSZip from 'jszip';
import { VendorInvoice } from 'types/invoices';
import { NspCoreInfo } from 'types/nspCoreInfo';
import { buildNspInvoiceBlob } from './nspInvoicePdfGenerator';

/**
 * Generate NSP invoice PDFs for a set of vendors, bundle them into a ZIP,
 * and trigger a browser download of the ZIP file.
 */
export const generateNspInvoicesZip = async ({
  vendors,
  primaryIssuer,
  monthYear,
  hstRate,
}: {
  vendors: VendorInvoice[];
  primaryIssuer: NspCoreInfo | null;
  monthYear: string;
  hstRate: number;
}): Promise<void> => {
  const zip = new JSZip();

  await Promise.all(
    vendors.map(async (vendor) => {
      const applyHst = vendor.apply_hst !== false;
      const { blob, filename } = await buildNspInvoiceBlob({
        vendor,
        primaryIssuer,
        monthYear,
        hstRate: applyHst ? hstRate : 0,
        applyHst,
      });
      zip.file(filename, blob);
    })
  );

  const zipBlob = await zip.generateAsync({ type: 'blob' });

  // Trigger browser download
  const url = URL.createObjectURL(zipBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `NSP_Invoices_${monthYear}.zip`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
